import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_ARTGAMME_SCHEMA_LITERAL = {
    title: 'Schéma ArtGammes',
    description: 'Décrit les déclinaisons de gamme',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'AG_NO_PK', fields : ['AG_NO'], separator : '' },
    type: 'object',
    properties: {
        AG_NO_PK: { type: 'string', maxLength : 10 },
        AG_NO: { type: 'number' },
        AR_REF: { type: 'string' },
        EG_ENUMERE: { type: 'string' },
        AG_TYPE: { type: 'number' }
    },
    required: [ 'AG_NO', 'AR_REF', 'EG_ENUMERE', 'AG_TYPE' ] //
} as const;

const schemaTyped = toTypedRxJsonSchema(F_ARTGAMME_SCHEMA_LITERAL);
export type RxFArtGammeDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_ARTGAMME_SCHEMA: RxJsonSchema<RxFArtGammeDocumentType> = F_ARTGAMME_SCHEMA_LITERAL;
